import { jsx as _jsx } from "react/jsx-runtime";
import { useClassName } from '../../hooks';
import { useIcon } from './hooks';
import './Icon.scss';
/**
 * Icon component used to display icons.
 */
export const Icon = (props) => {
    const IconComponent = useIcon(props.name);
    const className = useClassName({ name: 'icon', prefixed: true }, props.color, props.size);
    return (_jsx("div", { className: className, children: _jsx(IconComponent, {}) }));
};
